import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { FC } from "react";

import type { AudioRecordingObservable } from "@/store/audio-recordings";
import { AudioRecordingDetailInfo } from "./info";
import { AudioRecordingDetailPageHeader } from "@/pages/audio-recordings/details/audio-recording-detail-page-header";

type Props = {
  recording: AudioRecordingObservable;
};

export const AudioRecordingDetailContent: FC<Props> = observer(({ recording }) => {
  return (
    <Container>
      <AudioRecordingDetailPageHeader recording={recording} />
      <AudioRecordingDetailInfo recordingId={recording.id} recording={recording} />
    </Container>
  );
});

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: red;
  gap: 1.5rem;
`;
